import { render, staticRenderFns } from "./Son_CheckArray.vue?vue&type=template&id=1d204a78&scoped=true&"
import script from "./Son_CheckArray.vue?vue&type=script&lang=js&"
export * from "./Son_CheckArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d204a78",
  null
  
)

export default component.exports